import  { useState } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { withStyles } from "@material-ui/core/styles";
import styles from "./faqsStyles";
import FaqDialog from "./FaqDialog";

const FaqsAdmin = ({ classes }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ mt: '110px', ml: '20px',height:"100vh" }} width="88%">
      <Grid container justifyContent="space-between" alignItems="center" sx={{ p: 2 }}>
        <Grid item>
          <Typography className={classes.faqText}>FAQs</Typography>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpen}>
            Create New FAQ
          </Button>
        </Grid>
      </Grid>

      <FaqDialog open={open} onClose={handleClose} />
    </Box>
  );
};

export default withStyles(styles)(FaqsAdmin);
